import { createSlice } from "@reduxjs/toolkit";

const referralSlice = createSlice({
  name: "referral",
  initialState: {
    loading: false,
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    error: null,
    newReferralCode: null,
  },
  reducers: {
    getReferralListRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getReferralListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data?.usedBy || [];
      state.total = action.payload.data?.total || 0;
      state.page = action.payload.data?.page || 1;
      state.limit = action.payload.data?.limit || 10;
    },
    getReferralListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createReferralRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.newReferralCode = null;
    },
    createReferralSuccess: (state, action) => {
      state.loading = false;
      state.newReferralCode = action.payload.data?.referralcode || null;
    },
    createReferralFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getReferralListRequest,
  getReferralListSuccess,
  getReferralListFailure,
  createReferralRequest,
  createReferralSuccess,
  createReferralFailure,
} = referralSlice.actions;

export default referralSlice.reducer;
